import _ = require("underscore");
import Base = require("./base/locator");
import Utils = require("../utils");

class Command extends Base {

    static about = `Overrides base/locator to perform a text search against all configured bookmarks.`;

    static options = Utils.defaults({
        "model": {
            "default": "app/data/bookmarks"
        },
        "search-field": {
            "default": "text"
        },
        "zoommap": {
            "default": "true"
        },
        "event": {
            "default": "bookmark-locator"
        },
    }, Base.options);

    execute(args = this.args) {
        _.defaults(this.options, {
            model: this.mediator.api.bookmarks,
            "search-field": "text",
            zoommap: "true",
            event: "bookmark-locator"
        });

        super.execute(args);
    }

}

export = Command; 